import React, { useRef, useState } from 'react';

import { useAuthContext } from '../../../Auth/AuthProvider';
import { PermissionEnum } from '../../../../types/PermissionEnum';
import { useStoreContext } from '../../../App/StoreProvider';
import { Alert, Dropdown, Table } from 'react-bootstrap';

import { Parser } from '@json2csv/plainjs';
import { useReactToPrint } from 'react-to-print';
import { useMutation, useQuery } from '@apollo/client/react';
import { CombinedGraphQLErrors } from '@apollo/client';
import { Loading, Error, CustomButton } from '../../../_common';
import { StageSheetPrintAllLayout } from './StageSheetPrintAllLayout';
import {
    GetDetailsForStageSheet,
    GetStageSheet,
    GetStageSheet_getStageSheet_propDetails as ProppantDetails,
    RevertStageSheet,
    GetStageSheet_getStageSheet_details as StageSheet,
    UpdateBox,
    UpdateInventoryWeight,
} from '../../../../types/schemaTypes';
import './StageSheet.scss';

import { Link, useParams } from 'react-router-dom';
import { Routes } from '../../../../utils/Routes';
import { GET_DETAILS_FOR_STAGE_SHEET, GET_STAGE_SHEET } from '../../../../graphql/client/queries';

import { NumericFormat as NumberFormat } from 'react-number-format';
import StageSheetRORevertMode from './StageSheetRORevertMode';
import { REVERT_STAGESHEET, UPDATE_BOX_WEIGHT, UPDATE_INVENTORY_WEIGHT } from '../../../../graphql/client/mutations';

import { ToastContainer, toast } from 'react-toastify';
import { toastOpt } from '../../../../utils/helpers/toastHelper'
import StageSheetEditLoadWeightModal from './StageSheetEditLoadWeightModal';
import JobMenuItems from '../../../Header/JobMenuItemsHeader/JobMenuItems';
import StageSheetBellyDumpRORevertMode from './StageSheetBellyDumpRORevertMode';
import StageSheetBellyDumpRevertMode from './StageSheetBellyDumpRevertMode';
import { StageSheetBellyDumpPrintAllLayout } from './StageSheetBellyDumpPrintAllLayout';

interface StageToRevertProps {
    stageSheetBoxId: number;
    loadId: number;
    weight: number;
    weightRemaining: number;
}

const StageSheetBellyDumpRO = ({ match }: any): React.ReactElement => {
    const authContext = useAuthContext();

    const isDisplayLoadsEnabled = authContext.userHasPermission(PermissionEnum.ViewLoads);
    const isViewStageSheetEnabled = authContext.userHasPermission(PermissionEnum.ViewStageHistory);
    const isRevertStageSheetEnabled = authContext.userHasPermission(PermissionEnum.RevertStageSheet);

    const isDownloadEnabled = authContext.userHasPermission(PermissionEnum.Download);
    const isPrintAllEnabled = authContext.userHasPermission(PermissionEnum.PrintAll);

    const [weightInvalidErrorList, setWeightInvalidErrorList] = useState<number[]>([]);
    const [weightZeroErrorList, setWeightZeroErrorList] = useState<number[]>([]);
    const [weightRemainingInvalidErrorList, setWeightRemainingInvalidErrorList] = useState<number[]>([]);
    const [weightRemainingErrorList, setWeightRemainingErrorList] = useState<number[]>([]);

    const [stageModalError, setStageModalError] = useState('');
    const [stageSheetToEditWeight, setStageSheetToEditWeight] = useState<StageSheet | undefined>();

    const [state, dispatch] = useStoreContext();

    const [tabTitle, setTabTitle] = useState(document.title);
    document.title = localStorage.getItem('Jobdetails-TabName') + tabTitle;
    const abortController = new AbortController();
    //const [showDownloadFilter, setShowDownloadFilter] = useState(false);
    const printAllComponentRef = useRef(null);
    const handlePrint = useReactToPrint({ contentRef: printAllComponentRef });

    let jobId = 0;
    let jobName: string | null = '';
    document.title = jobName;
    let wellheadStages: string | null = '';

    const [isRevertMode, setIsRevertMode] = useState(false);
    const [stagesToRevert, setStagesToRevert] = useState<StageToRevertProps[]>([]);

    const [showEditLoadWeightModal, setShowEditLoadWeightModal] = useState(false);
    const { stageSheetId } = useParams()
    const stageSheetIdVal: any = stageSheetId

    const toasterOptions = { duration: 2500 };
    const toastMessages = {
        revert: `Stages edited sucessfully`,
    };
    const errorMessages = {
        revert: `Stages could not be edited `,
    };
    const renderToast = (message, type = 'info') => {
        interface ToastProps {
            onClose?: () => void;
        }
        const Comp = (props: ToastProps) => {
            return (
                <Alert variant={type} onClose={props.onClose}>
                    {message}
                </Alert>
            );
        };
        Comp.displayName = 'toast';
        return Comp;
    };

    const { loading: detailsLoading, error: detailsError, data: details } = useQuery<GetDetailsForStageSheet>(GET_DETAILS_FOR_STAGE_SHEET, {
        variables: {
            stageSheetId: parseInt(stageSheetIdVal),
        },
        fetchPolicy: 'network-only',
    });
    if (details && details.getDetailsForStageSheet) {
        jobId = details.getDetailsForStageSheet.jobId;
        jobName = details.getDetailsForStageSheet.wellName;
        wellheadStages = details.getDetailsForStageSheet.wellheadStages;
        document.title = jobName ?? tabTitle;
    }

    const { loading: stageSheetLoading, error: stageSheetError, data: stageSheetData } = useQuery<GetStageSheet>(GET_STAGE_SHEET, {
        variables: {
            stageSheetId: parseInt(stageSheetIdVal),
        },
        fetchPolicy: 'network-only',
    });
    let stageSheetsGrd: StageSheet[] = [];
    let proppantDetails: ProppantDetails[] = [];
    if (stageSheetData?.getStageSheet) {
        proppantDetails = (stageSheetData.getStageSheet.propDetails ?? []).filter((p): p is ProppantDetails => p != null);
        stageSheetsGrd = (stageSheetData.getStageSheet.details ?? []).filter((d): d is StageSheet => d != null);
    }

    const handleOnCompleteRevert = () => {
        setIsRevertMode(false);
        setStagesToRevert([]);
        toast.success(toastMessages.revert, toastOpt);

    };
    const [revertStageSheet, { loading: revertStageSheetLoading }] = useMutation<RevertStageSheet>(REVERT_STAGESHEET, {
        onCompleted: () => handleOnCompleteRevert(),
        onError: error => {
            if (CombinedGraphQLErrors.is(error)) {
                toast.error(errorMessages.revert + (error.errors[0]?.message?.toString().replace(',', ' ') || error.message), toastOpt);

            } else {
                toast.error(errorMessages.revert + (error.message ?? error), toastOpt);

            }
        },
        refetchQueries: [
            {
                query: GET_STAGE_SHEET,
                variables: {
                    stageSheetId: parseInt(stageSheetIdVal),
                },
            },
        ],
    });

    const handleOnClickRevert = () => {
        setIsRevertMode(true);
    };

    const handleOnClickCancelRevert = () => {
        setIsRevertMode(false);
        setStagesToRevert([]);
        setWeightInvalidErrorList([]);
        setWeightZeroErrorList([]);
        setWeightRemainingInvalidErrorList([]);
        setWeightRemainingErrorList([]);
    };

    const handleOnSaveRevert = () => {
        const tempWeightInvalidErrorList: number[] = [];
        const tempWeightZeroErrorList: number[] = [];
        const tempWeightRemainingInvalidErrorList: number[] = [];
        const tempWeightRemainingErrorList: number[] = [];

        if (stagesToRevert.length !== 0) {
            let isError = false;
            stagesToRevert.map(stageToRevert => {
                if (isNaN(stageToRevert.weight)) {
                    isError = true;
                    tempWeightInvalidErrorList.push(stageToRevert.stageSheetBoxId);
                }
                if (stageToRevert.weight === 0) {
                    isError = true;
                    tempWeightZeroErrorList.push(stageToRevert.stageSheetBoxId);
                }
                if (isNaN(stageToRevert.weightRemaining)) {
                    isError = true;
                    tempWeightRemainingInvalidErrorList.push(stageToRevert.stageSheetBoxId);
                }
                if (stageToRevert.weightRemaining > stageToRevert.weight) {
                    isError = true;
                    tempWeightRemainingErrorList.push(stageToRevert.stageSheetBoxId);
                }
            });

            setWeightInvalidErrorList(tempWeightInvalidErrorList);
            setWeightZeroErrorList(tempWeightZeroErrorList);
            setWeightRemainingInvalidErrorList(tempWeightRemainingInvalidErrorList);
            setWeightRemainingErrorList(tempWeightRemainingErrorList);

            if (!isError)
                revertStageSheet({
                    variables: {
                        input: {
                            stageSheetDetails: stagesToRevert,
                            jobStatus: 'Completed',
                        },
                    },
                });
        }
    };

    const downloadFileHandler = () => {
            const stageSheetDetails: StageSheet[] = (stageSheetData?.getStageSheet?.details ?? []).filter(
                (d): d is StageSheet => d != null
            );
            if (stageSheetDetails.length !== 0) {
                const stageSheetDetailsList = stageSheetDetails.map(stageSheetDetail => {
                    if (stageSheetDetail.station == '0') {
                        const stageSheetDetailMirror = { ...stageSheetDetail }
                        stageSheetDetailMirror.station = '';
                        stageSheetDetail = { ...stageSheetDetailMirror }
                    }
                    const record: Record<string, string | number> = {
                        'Station#': stageSheetDetail.station ?? '',
                        Box: stageSheetDetail.boxDesc ?? '',
                        Weight: stageSheetDetail.boxWeight ?? '',
                        'Accumulated Weight': stageSheetDetail.accumulatedWeight ?? '',
                        Type: stageSheetDetail.proppant ?? '',
                        'Pad Location': stageSheetDetail.location ?? '',
                        'Wt. Remaining': stageSheetDetail.boxWeightRemaining ?? '',
                        OOS: stageSheetDetail.isOOS ? 'Yes' : 'No',
                        'PO #': (stageSheetDetail.sandPo ?? '') + '\t',
                        'Origin #': (stageSheetDetail.lofaOrigin ?? '') + '\t',
                    };

                    if (!stageSheetDetail.stageSheetBellyDump || stageSheetDetail.stageSheetBellyDump.length === 0) {
                        record['Ticket #'] = (stageSheetDetail.sandTicket ?? '') + '\t';
                        record['Load#'] = String(stageSheetDetail.loadId ?? '') + '\t';
                    }
    
                    if (stageSheetDetail.stageSheetBellyDump && stageSheetDetail.stageSheetBellyDump.length > 1) {
                        stageSheetDetail.stageSheetBellyDump.forEach((load, index) => {
                            record[`Load #${index + 1}`] = load?.loadId + '\t';
                            record[`Ticket #${index + 1}`] = load?.sandTicket + '\t';
                            record[`Weight #${index + 1}`] = load?.sandTicketWeight + '\t';
                            record[`Weight Remaining #${index + 1}`] = load?.sandTicketWeightRemaining + '\t';
                        });
                    }
    
    
                    return record;
                });
    
                const opts = {};
                const parser = new Parser(opts);
                const csvData = parser.parse(stageSheetDetailsList);
                const file = new Blob([csvData], { type: 'application/csv' });
                const url = window.URL.createObjectURL(file);
                const a = document.createElement('a');
                a.href = url;
                a.download = `Stage Sheet.csv`;
                a.click();
            }
        };

    const handleOnClickEditLoadWeight = stageSheet => {
        setStageSheetToEditWeight(stageSheet);
        setShowEditLoadWeightModal(true);
    };
    const handleOnClickCancelEditLoadWeight = () => {
        setStageModalError('');
        setShowEditLoadWeightModal(false);
        setStageSheetToEditWeight(undefined);
    };

    const [updateInventoryWeight, { loading: updateInventoryWeightLoading }] = useMutation<UpdateInventoryWeight>(
        UPDATE_INVENTORY_WEIGHT,
        {
            onError: error => {
                if (CombinedGraphQLErrors.is(error)) {
                    setStageModalError(error.errors[0]?.message?.toString().replace(',', ' ') || error.message);
                } else {
                    setStageModalError(error.message ?? error);
                }
            },
        },
    );

    const [updateBoxWeight, { loading: updateBoxWeightLoading }] = useMutation<UpdateBox>(UPDATE_BOX_WEIGHT, {
        onError: error => {
            if (CombinedGraphQLErrors.is(error)) {
                setStageModalError(error.errors[0]?.message?.toString().replace(',', ' ') || error.message);
            } else {
                setStageModalError(error.message ?? error);
            }
        },
        onCompleted: () => {
            handleOnClickCancelEditLoadWeight();
        },
        refetchQueries: [
            {
                query: GET_STAGE_SHEET,
                variables: {
                    stageSheetId: parseInt(stageSheetIdVal),
                },
            },
        ],
    });

    const handleOnSaveEditLoadWeight = async (boxId, loadId, inventoryWeight, oldInventoryWeight, stageSheetBoxId) => {
        const result = await updateInventoryWeight({
            variables: {
                input: {
                    boxId: boxId,
                    loadId: loadId,
                    inventoryWeight: inventoryWeight,
                },
            },
        });

        // if (result && result['data']['updateInventoryWeight']['errors'].length === 0) {
        if (result && result['data'] && result['data']['updateInventoryWeight'] && result['data']['updateInventoryWeight']['errors'] && result['data']['updateInventoryWeight']['errors'].length == 0) {
            await updateBoxWeight({
                variables: {
                    input: {
                        boxId: boxId,
                        loadId: loadId,
                        inventoryWeight: inventoryWeight,
                        oldInventoryWeight: oldInventoryWeight,
                        stageSheetBoxId: stageSheetBoxId,
                    },
                },
            });
        }
    };

    if (!isViewStageSheetEnabled) {
        return (
            <div className="StageSummary-Container">
                <ToastContainer />
                <div className="StageSummary-Header-Container">
                    <div className="StageSummary-Header">Stage Summary: {jobName}</div>
                    <div style={{ width: 250 }}></div>

                    <JobMenuItems jobId={jobId.toString()} menu='stageSummary'/>
                </div>

                <div className="NoResult-Container StageSummary-Unauth-Container">
                    <div className="NoResult-First-Title-Secondary">Unauthorized</div>
                    <div className="NoResult-First-Title-Primary">You do not have permission to view this screen</div>
                </div>
            </div>
        );
    }

    return (
        <div className="Messages-Container">
            <ToastContainer />
            <div className="StageSheet-Header-Container">
                <div className="StageSheet-Header">Stage Sheet: {jobName}</div>
                {detailsLoading && (
                    <div className="StageSheet-Header-Loading">
                        <Loading />
                    </div>
                )}

                <JobMenuItems jobId={jobId.toString()} menu='stageSummary'/>
            </div>

            <div className="StageSheet-Subheader-Container">
                <Link
                    to={{
                        pathname: `${Routes.STAGE_SUMMARY.route}${jobId}`,
                    }}
                    className="StageSheet-Back-Button"
                >
                    Back
                </Link>
                <div className="StageSheet-Button-Container">
                    {isPrintAllEnabled && (
                        <button className="StageSheet-Button" onClick={handlePrint}>
                            <i className="material-icons StageSheet-Icons">print</i>
                            Print All
                        </button>
                    )}
                    {isDownloadEnabled && (
                        <button className="StageSheet-Button" onClick={downloadFileHandler}>
                            <i className="material-icons StageSheet-Icons">get_app</i>
                            Download
                        </button>
                    )}
                </div>
                <div className="StageSheet-Button-Container-For-Tab">
                    <Dropdown className="JobProfile-CenterToggleButton-Container">
                        <Dropdown.Toggle
                            variant="link"
                            id="dropdown-basic"
                            className="JobProfile-CenterToggleButton JobProfile-CenterToggleButton-Container Stagesheet-Actions"
                        >
                            <span>Actions</span>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item>
                                {isPrintAllEnabled && (
                                    <button className="StageSheet-Dropdown-Button" onClick={handlePrint}>
                                        <i className="material-icons StageSheet-Icons">print</i>
                                        Print All
                                    </button>
                                )}
                            </Dropdown.Item>
                            <Dropdown.Item>
                                {isDownloadEnabled && (
                                    <button className="StageSheet-Dropdown-Button" onClick={downloadFileHandler}>
                                        <i className="material-icons StageSheet-Icons">get_app</i>
                                        Download
                                    </button>
                                )}
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            </div>

            <div className="StageSheet-Stages">{wellheadStages}</div>

            <div className="StageSheet-Grid-Container">
                <Table striped bordered className="tabletest StageSheet-Proppant-Details-Grid">
                    <thead>
                        <tr>
                            <th>Proppant</th>
                            <th>Total Weight Needed</th>
                            <th>Sand Pumped</th>
                            <th>Cumulative Box Weight</th>
                        </tr>
                    </thead>
                    <tbody>
                        {stageSheetLoading || revertStageSheetLoading ? (
                            <div className="StageSheet-ProppantDetails-Spinner-Container">
                                <Loading />
                            </div>
                        ) : proppantDetails.length === 0 ? (
                            <tr>
                                <td colSpan={4}>
                                    <div className="NoResult-Second-Title-Primary">No Proppant Details Found.</div>
                                </td>
                            </tr>
                        ) : (
                            proppantDetails.map((proppantDetail, index) => (
                                <tr key={index}>
                                    <td>{proppantDetail.proppantName}</td>
                                    <td
                                        className={
                                            proppantDetail.totalWeightNeeded && proppantDetail.totalWeightNeeded < 0
                                                ? 'Td-Red-Background'
                                                : ''
                                        }
                                    >
                                        <NumberFormat
                                            value={proppantDetail.totalWeightNeeded || 0}
                                            displayType={'text'}
                                            thousandSeparator={true}
                                        />
                                    </td>
                                    <td>
                                        <NumberFormat
                                            value={proppantDetail.sandPumped || 0}
                                            displayType={'text'}
                                            thousandSeparator={true}
                                        />
                                    </td>
                                    <td>
                                        <NumberFormat
                                            value={proppantDetail.totalBoxWeight || 0}
                                            displayType={'text'}
                                            thousandSeparator={true}
                                        />
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </Table>
            </div>

            {isRevertStageSheetEnabled && !revertStageSheetLoading && (
                <div className="StageSheet-Edit-Container">
                    {!isRevertMode ? (
                        <div className="StageSheet-Edit-Button-Container">
                            <div className="StageSheet-Edit-Button" onClick={() => handleOnClickRevert()}>
                                <i className="material-icons StageSheet-Edit-Icon">replay</i>
                                Revert
                            </div>
                        </div>
                    ) : (
                        <div className="StageSheet-Cancel-Save-Button">
                            <CustomButton
                                title="Cancel"
                                isBordered
                                onClick={() => handleOnClickCancelRevert()}
                                isDisabled={revertStageSheetLoading}
                            />
                            <div className="StageSheet-Save-Button">
                                <CustomButton
                                    title="Save"
                                    onClick={() => {
                                        handleOnSaveRevert();
                                    }}
                                    isDisabled={revertStageSheetLoading}
                                />
                            </div>
                        </div>
                    )}
                </div>
            )}

            {/* For Laptop */}
            <div className="StageSheet-Grid-Container StageSheet-Container">
                <Table striped bordered className="tabletest StageSheet-Grid">
                    <thead>
                        <tr>
                            <th className="StageSheet-Grid-Sm StageSheet-Grid-Header">Station #</th>
                            <th className="StageSheet-Grid-Sm StageSheet-Grid-Header">Box</th>
                            <th className="StageSheet-Grid-Sm StageSheet-Grid-Header">Box Wt.</th>
                            <th className="StageSheet-Grid-Sm StageSheet-Grid-Header">Box Wt. Remaining</th>
                            <th className="StageSheet-Grid-Sm StageSheet-Grid-Header">Type</th>
                            <th className="StageSheet-Grid-Lg StageSheet-Grid-Header">Pad Location</th>
                            <th className="StageSheet-Grid-Md StageSheet-Grid-Header">OOS</th>
                            <th className="StageSheet-Grid-XLg StageSheet-Grid-Header">Box Action</th>
                            <th className="StageSheet-Grid-Lg StageSheet-Grid-Header">PO #</th>
                            <th className="StageSheet-Grid-Lg StageSheet-Grid-Header">Origin #</th>
                            <th className="StageSheet-Grid-Md StageSheet-Grid-Header">Load#</th>
                            <th className="StageSheet-Grid-Md StageSheet-Grid-Header">Sand Ticket #</th>
                            <th className="StageSheet-Grid-Md StageSheet-Grid-Header StageSheet-Grid-Wt">
                                ST Weight
                            </th>
                            <th className="StageSheet-Grid-Md StageSheet-Grid-Header StageSheet-Grid-Wt">
                                ST Wt. Remaining
                            </th>
                            {/* <th className="StageSheet-Grid-XLg StageSheet-Grid-Header">Action</th> */}
                    </tr>
                    </thead>
                    
                    {stageSheetError && <Error error={stageSheetError} />}

                    {stageSheetLoading || revertStageSheetLoading ? (
                        <div className="StageSheet-StageSheet-Spinner-Container">
                            <Loading />
                        </div>
                    ) : !stageSheetsGrd || stageSheetsGrd.length === 0 ? (
                        <tbody>
                            <tr>
                                <td colSpan={10}>
                                    <div className="NoResult-Second-Title-Primary">No Stage Sheet Details Found.</div>
                                </td>
                            </tr>
                        </tbody>
                    ) : (
                        <tbody>
                            {isRevertMode
                                ? stageSheetsGrd.map((stageSheet, index) => (
                                    <StageSheetBellyDumpRORevertMode
                                        key={index}
                                        stageSheet={stageSheet}
                                        setStagesToRevert={setStagesToRevert}
                                        stagesToRevert={stagesToRevert}
                                        weightInvalidErrorList={weightInvalidErrorList}
                                        setWeightInvalidErrorList={setWeightInvalidErrorList}
                                        weightZeroErrorList={weightZeroErrorList}
                                        setWeightZeroErrorList={setWeightZeroErrorList}
                                        weightRemainingInvalidErrorList={weightRemainingInvalidErrorList}
                                        setWeightRemainingInvalidErrorList={setWeightRemainingInvalidErrorList}
                                        weightRemainingErrorList={weightRemainingErrorList}
                                        setWeightRemainingErrorList={setWeightRemainingErrorList}
                                        isRevertStageSheetEnabled={isRevertStageSheetEnabled}
                                    />
                                ))
                                : stageSheetsGrd.map((stageSheet, index) => (
                                    <>
                                        {stageSheet.stageSheetBellyDump?.map((load, loadIndex) => (
                                            <tr key={index}>
                                                {loadIndex === 0 && (
                                                    <>
                                                        <td rowSpan={stageSheet.stageSheetBellyDump?.length}>{stageSheet.station === '0' ? '' : stageSheet.station}</td>
                                                        <td rowSpan={stageSheet.stageSheetBellyDump?.length}>
                                                            <div className="StageSheet-GreenDot-Container">
                                                                {stageSheet.boxDesc}
                                                                {stageSheet.isPartial === 'Yes' && (
                                                                    <div className="StageSheet-GreenDot" />
                                                                )}
                                                            </div>
                                                        </td>
                                                        <td rowSpan={stageSheet.stageSheetBellyDump?.length}>
                                                            <NumberFormat
                                                                value={stageSheet.boxWeight ?? 0}
                                                                displayType={'text'}
                                                                thousandSeparator={true}
                                                            />
                                                        </td>
                                                        <td rowSpan={stageSheet.stageSheetBellyDump?.length}>
                                                            <NumberFormat
                                                                value={stageSheet.boxWeightRemaining ?? 0}
                                                                displayType={'text'}
                                                                thousandSeparator={true}
                                                            />
                                                        </td>
                                                        <td rowSpan={stageSheet.stageSheetBellyDump?.length}>{stageSheet.proppant}</td>
                                                        <td rowSpan={stageSheet.stageSheetBellyDump?.length}>{stageSheet.location}</td>
                                                        
                                                        <td rowSpan={stageSheet.stageSheetBellyDump?.length}>{stageSheet.isOOS ? 'Yes' : 'No'}</td>
                                                        <td rowSpan={stageSheet.stageSheetBellyDump?.length}>
                                                            {/* <div className="StageSheet-Buttons-Container">
                                                                <button
                                                                    className="StageSheet-Buttons StageSheet-LoadWeight-Buttons-For-Tab"
                                                                    onClick={() => handleOnClickEditLoadWeight(stageSheet)}
                                                                >
                                                                    Edit Delivered Wt
                                                                </button>
                                                            </div> */}
                                                        </td>
                                                        <td rowSpan={stageSheet.stageSheetBellyDump?.length}>{stageSheet.sandPo}</td>
                                                        <td rowSpan={stageSheet.stageSheetBellyDump?.length}>{stageSheet.lofaOrigin}</td>
                                                    </>
                                                )}
                                                
                                                <td>{load?.loadId}</td>
                                                <td>{load?.sandTicket}</td>
                                                <td>{load?.sandTicketWeight}</td>
                                                <td>{load?.sandTicketWeightRemaining}</td>
                                                {/* {isRevertStageSheetEnabled && (
                                                    <td>
                                                        <div className="StageSheet-Buttons-Container">
                                                            <button
                                                                className="StageSheet-Buttons StageSheet-LoadWeight-Buttons-For-Tab"
                                                                onClick={() => handleOnClickEditLoadWeight(stageSheet)}
                                                            >
                                                                Edit Delivered Wt
                                                            </button>
                                                        </div>
                                                    </td>
                                                )} */}
                                            </tr>
                                        ))}
                                    </>
                                ))}
                        </tbody>
                    )}
                </Table>
            </div>

            {/* For tablet */}
            {stageSheetLoading || revertStageSheetLoading ? (
                <div className="StageSheet-Container-For-Tab">
                    <div className="StageSheet-StageSheet-Spinner-Container">
                        <Loading />
                    </div>
                </div>
            ) : (
                <div className="StageSheet-Container-For-Tab">
                    {stageSheetError && <Error error={stageSheetError} />}

                    {!stageSheetLoading &&
                        !revertStageSheetLoading &&
                        (!stageSheetsGrd || stageSheetsGrd.length === 0) ? (
                        <div className="NoResult-Second-Title-Primary">No Box Details Available.</div>
                    ) : isRevertMode ? (
                        stageSheetsGrd.map((stageSheet, index) => (
                            <StageSheetBellyDumpRORevertMode
                                key={index}
                                stageSheet={stageSheet}
                                setStagesToRevert={setStagesToRevert}
                                stagesToRevert={stagesToRevert}
                                weightInvalidErrorList={weightInvalidErrorList}
                                setWeightInvalidErrorList={setWeightInvalidErrorList}
                                weightZeroErrorList={weightZeroErrorList}
                                setWeightZeroErrorList={setWeightZeroErrorList}
                                weightRemainingInvalidErrorList={weightRemainingInvalidErrorList}
                                setWeightRemainingInvalidErrorList={setWeightRemainingInvalidErrorList}
                                weightRemainingErrorList={weightRemainingErrorList}
                                setWeightRemainingErrorList={setWeightRemainingErrorList}
                                isRevertStageSheetEnabled={isRevertStageSheetEnabled}
                            />
                        ))
                    ) : (
                        stageSheetsGrd.map((stageSheet, index) => (
                            <div className="StageSheet-Tab-Item-Container" key={index}>
                                <div className="StageSheet-Tab-Item">
                                    <div className="StageSheet-KeyValues">
                                        <span className="StageSheet-Key">Station #:</span>
                                        <span className="StageSheet-Value">
                                            {stageSheet.station === '0' ? '' : stageSheet.station}
                                        </span>
                                    </div>
                                    <div className="StageSheet-KeyValues">
                                        <span className="StageSheet-Key">PO #:</span>
                                        <span className="StageSheet-Value">{stageSheet.sandPo}</span>
                                    </div>
                                    <div className="StageSheet-KeyValues">
                                        <span className="StageSheet-Key">Box Wt:</span>
                                        <span className="StageSheet-Value">
                                            <NumberFormat
                                                value={stageSheet.boxWeight || 0}
                                                displayType={'text'}
                                                thousandSeparator={true}
                                            />
                                        </span>
                                    </div>
                                    {stageSheet.stageSheetBellyDump?.map((load, idx) => (
                                        <div key={idx} className="StageSheet-KeyValues">
                                            <span className="StageSheet-Key">Ticket {idx + 1} :</span>
                                            <span className="StageSheet-Value">
                                            {load?.sandTicket || 0}
                                            </span>
                                        </div>
                                    ))}
                                </div>

                                <div className="StageSheet-Tab-Item StageSheet-Tab-Item-Lg">
                                    <div className="StageSheet-KeyValues">
                                        <span className="StageSheet-Key">Origin:</span>
                                        <span className="StageSheet-Value">{stageSheet.lofaOrigin}</span>
                                    </div>
                                    <div className="StageSheet-KeyValues">
                                        <span className="StageSheet-Key">Pad Location:</span>
                                        <span className="StageSheet-Value">{stageSheet.location}</span>
                                    </div>
                                    <div className="StageSheet-KeyValues">
                                        <span className="StageSheet-Key">Box Wt Remaining:</span>
                                        <span className="StageSheet-Value">
                                            <NumberFormat
                                                value={stageSheet.boxWeightRemaining || 0}
                                                displayType={'text'}
                                                thousandSeparator={true}
                                            />
                                        </span>
                                    </div>
                                    {stageSheet.stageSheetBellyDump?.map((load, idx) => (
                                        <div key={idx} className="StageSheet-KeyValues">
                                            <span className="StageSheet-Key">St Wt/ St Wt Remaining:</span>
                                            <span className="StageSheet-Value">
                                                <NumberFormat
                                                    value={load?.sandTicketWeight || 0}
                                                    displayType={'text'}
                                                    thousandSeparator={true}
                                                />
                                                /
                                                <NumberFormat
                                                    value={load?.sandTicketWeightRemaining || 0}
                                                    displayType={'text'}
                                                    thousandSeparator={true}
                                                />
                                            </span>
                                        </div>
                                    ))}
                                </div>

                                <div className="StageSheet-Tab-Item">
                                    <div className="StageSheet-KeyValues">
                                        <span className="StageSheet-Key">Box:</span>
                                        <span className="StageSheet-Value">
                                            <div className="StageSheet-GreenDot-Container">
                                                {stageSheet.boxDesc}
                                                {stageSheet.isPartial === 'Yes' && (
                                                    <div className="StageSheet-GreenDot" />
                                                )}
                                            </div>
                                        </span>
                                    </div>
                                    <div className="StageSheet-KeyValues">
                                        <span className="StageSheet-Key">Type:</span>
                                        <span className="StageSheet-Value">{stageSheet.proppant}</span>
                                    </div>
                                    <br />
                                    {stageSheet.stageSheetBellyDump?.map((load, idx) => (
                                        <div key={idx} className="StageSheet-KeyValues">
                                            <span className="StageSheet-Key">Load {idx + 1} #:</span>
                                            <span className="StageSheet-Value">
                                            {load?.loadId || 0}
                                            </span>
                                        </div>
                                    ))}
                                </div>

                                {/* <div className="StageSheet-Tab-Button-Item">
                                    <div className="StageSheet-KeyValues">
                                        <span className="StageSheet-Key">OOS:</span>
                                        <span className="StageSheet-Value">{stageSheet.isOOS ? 'Yes' : 'No'}</span>
                                    </div>
                                    {isRevertStageSheetEnabled && (
                                        <button
                                            className="StageSheet-Buttons-For-Tab StageSheet-LoadWeight-Buttons-For-Tab"
                                            onClick={() => handleOnClickEditLoadWeight(stageSheet)}
                                        >
                                            Edit Delivered Wt
                                        </button>
                                    )}
                                </div> */}
                            </div>
                        ))
                    )}
                </div>
            )}

            <div className="StageSheet-Layout-To-print">
                <StageSheetBellyDumpPrintAllLayout
                    innerRef={printAllComponentRef}
                    wellheadStages={wellheadStages ?? ''}
                    jobName={jobName ?? ''}
                    proppantDetails={proppantDetails}
                    stageSheets={stageSheetsGrd}
                />
            </div>

            {showEditLoadWeightModal && stageSheetToEditWeight && (
                <StageSheetEditLoadWeightModal
                    jobId={jobId}
                    showModal={showEditLoadWeightModal}
                    stageSheet={stageSheetToEditWeight}
                    handleOnClose={handleOnClickCancelEditLoadWeight}
                    handleOnSave={handleOnSaveEditLoadWeight}
                    mutationError={stageModalError}
                    mutationLoading={updateBoxWeightLoading || updateInventoryWeightLoading}
                />
            )}
        </div>
    );
};

export default StageSheetBellyDumpRO;
